import { useState, useEffect } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $recipientListStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { RecipientsTable } from './recipientsTable';
import { Button, Icon, SearchInput, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

const DEFAULT_TITLE = 'Recipients';

interface IListProps {
  className?: string;
  title?: React.ReactNode;
}

export const List = (props: IListProps) => {
  const recipientListStore = useUnit($recipientListStore.store);

  const [textSearch, setTextSearch] = useState<string>('');
  const [index, setIndex] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [count, setCount] = useState<number>(10);

  const { navigate } = useRouteHook();

  useEffect(() => {
    $recipientListStore.events.update({
      Count: count,
      FromIndex: (index - 1) * count,
      SearchQuery: textSearch,
      ReturnTotalCount: true,
    });
  }, [textSearch, count, index]);

  useEffect(() => {
    setTotal(recipientListStore?.data?.total);
  }, [recipientListStore?.data?.total, index, $recipientListStore, count]);

  const setSelectedItemId = (id: string) => navigate(RoutePaths.paymentsRecipient.onNavigate(id));

  return (
    <div className={clsx('flex flex-col gap-6', props.className)}>
      <div>
        <Text weight='semibold' size='2xl'>
          {props.title || DEFAULT_TITLE}
        </Text>
        <div className='flex items-center justify-end'>
          <div className='flex gap-3'>
            <SearchInput className='flex-grow flex-shrink-0 flex-basis-0' value={textSearch} onChange={setTextSearch} />
            <Button color='outlined' to={RoutePaths.paymentNewRecipients.onNavigate()}>
              <Icon icon={<PlusIcon />} color='inherit' />
              Add new recipient
            </Button>
          </div>
        </div>
      </div>
      <RecipientsTable
        data={recipientListStore.data.data}
        currentPage={index}
        totalItemCount={total}
        countItemPage={count}
        onChangePage={setIndex}
        onChangeCountItemPage={setCount}
        setSelectedItemId={setSelectedItemId}
        isLoading={recipientListStore?.loading}
      />
    </div>
  );
};
